var deserializeError = require('./lib/').default
module.exports = deserializeError
